import React, { useContext } from 'react';
import api from '../api';
import { Context } from '../contexts/StateContext';

//----------------------------------------------------
export function Api_Veiculos() {
    const { state, dispatch } = useContext(Context);
    const { cliente, logado } = state.cliente;
    const { veiculo, cotacao } = state.veiculo;
    const { franquia } = state.franquia;
    const { parametroInit, playLista, playmodal, listaPesquisa, displayModal } = state.parametros;
    const { id_Cliente } = cliente;
    const { id_Tipo, id_Veiculo } = veiculo;

    // ----------Add------------------
    async function AddPlaca() {
        try {
            const res = await api.post('/veiculo', {
                userCadastro: logado.idLogado? logado.idLogado : null,
                id_Franquia: franquia.id? franquia.id : null,
                id_Cliente: cliente.id_Cliente? cliente.id_Cliente : null,
                placa: veiculo.placa,
                modelo: veiculo.modelo,
                tipo: veiculo.tipo,
                marca: veiculo.marca,
                valorFipe: veiculo.valorFipe,
                anoMod: veiculo.anoMod,
                cor: veiculo.cor,
                chassi: veiculo.chassi,
                situacao: veiculo.situacao,

            })
            if (res.data) {
                alert('Placa Adicionada!');
                dispatch({
                    type: 'set_veiculo',
                    payload: {
                        ...veiculo,
                        id_Veiculo: res.data._id,
                        placa: res.data.placa,
                        modelo: res.data.modelo,
                        tipo: res.data.tipo,
                        nomeFranquia: res.data?.id_Franquia?.nome
                    }
                });
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaVeiculo: [res.data],
                        nomeItem: "",
                        selectItem: '',
                    }
                });
            };
            return res.data;
            
        } catch (error) {
            alert("!!!! Ocorreu um erro..!!!!", error);
            return error;
            
        }
    };

    // ----------COTACAO------------------
    async function AddCotacao() {
        try {
            const res = await api.post('/veiculo/cotacao', {
                id_Veiculo: veiculo?.id_Veiculo || null,
                id_Franquia: franquia?.id || null,

                registros: [
                    {
                        valorFipe: veiculo?.valorFipe || null,
                        valorCotacao: veiculo?.valorMensal || null,
                        valorAdesao: veiculo?.valorAdesao || null,
                        whatsapp: veiculo?.whatsapp_Cotacao || cliente?.celular || null,
                        status: 'P',
                    }
                ]

            })
            if (res.data) {
                alert('Cotação Adicionada!');
                dispatch({
                    type: 'set_cotacao',
                    payload: {
                        ...cotacao,
                        id_Cotacao: res.data._id,
                        id_Veiculo: res.data.id_Veiculo,
                        valorFipe: res.data.valorFipe,
                        valorCotacao: res.data.valorCotacao,
                        valorAdesao: res.data.valorAdesao,
                        whatsapp: res.data.whatsapp,
                        nomeFranquia: res.data?.id_Franquia?.nome
                    }
                });
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaCotacao: [res.data],
                    }
                });
            };
            return res.data;
            
        } catch (error) {
            alert("!!!!erro.. AddCotacao!!!!", error.message);
            console.error('Erro em AddCotacao:: ' + error.message);
            return null;
        }
    };
    // ---------------------------------------
    async function pesqCotacao_Id() {
        if (id_Veiculo) {
            try {
                const res = await api.get(`veiculo/cotacao/${id_Veiculo}`);
                if (res.data) {
                    // Filtrar res.data.registros para obter apenas os registros com status diferente de 'E'
                    const registrosAtivos = res.data.registros.filter(registro => registro.status !== 'E')
                    .sort((a, b) => new Date(b.data) - new Date(a.data)); // Ordenar por data (mais recente primeiro)
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: {
                            ...listaPesquisa,
                            listaCotacao: registrosAtivos,
                        }
                    });
                }

                return res.data;
            } catch (error) {
                alert("!!!!erro.. pesqCotacao_Id!!!!", error.message);
                console.error('Erro em pesqCotacao_Id:: ' + error.message);
                return null;
            }
        }
    };

    // ---------------------------------------
    async function pesqTodasCotacoes() {
        try {
            const res = await api.get(`veiculo/cotacaoTudo`);
            if (!Array.isArray(res.data)) {
                throw new Error('Formato inesperado na resposta de cotacoes.');
            }

            const registrosAtivos = res.data.reduce((registros, cotacao) => {
                const veiculoCotacao = cotacao.id_Veiculo;
                const ativos = (Array.isArray(cotacao.registros) ? cotacao.registros : [])
                    .filter(registro => registro.status !== 'E')
                    .map(registro => ({
                        ...registro,
                        id_Cotacao: cotacao._id,
                        id_Veiculo: veiculoCotacao,
                        placa: veiculoCotacao?.placa || cotacao.placa,
                    }));

                return registros.concat(ativos);
            }, [])
                .sort((a, b) => new Date(b.data) - new Date(a.data));
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaCotacao: registrosAtivos,
                }
            });

            return registrosAtivos;
        } catch (error) {
            const mensagem = error.response?.data?.message || error.message;
            alert(`Erro ao buscar todas as cotacoes: ${mensagem}`);
            console.error('Erro em pesqTodasCotacoes::', error);
            return null;
        }
    };

    // ----------------------------------------------
    async function PesqVeiXcliente() {
        if (id_Cliente) {
            await api.get(`veiculo/filtrar/${id_Cliente}`)
                .then(res => {
                    const buscar = res.data;
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaVeiculo: buscar }
                    });
                })
        }
    };

    //---------------Listar Todos Tipos Veic----------
    async function TodosTipos() {
        await api.get(`/tipoveic/todostipo`)
            .then(res => {
                const busca = res.data;

                dispatch({
                    type: 'set_veiculo',
                    payload: { ...veiculo, listaTipo: busca }
                });
            });
    };

    //---------------Listar Todos Planos--------------
    async function TodosPlanos() {
        await api.get(`/tipoveic/todosplanos`)
            .then(res => {
                const busca = res.data;
                const result = busca.map(s => ({ value: s._id, label: s.titulo }));
                return result;
            });
    };

    //----Listar Todos Planos Por Tipo--------------
    async function PlanosTipo() {
        if (id_Tipo) {
            await api.get(`tipoveic/planos/${id_Tipo}`)
                .then(res => {
                    const busca = res.data.id_Planos;
                    return busca;
                });
        }
    };

    // ---------------------------------------------------
    async function PesqVeiculoPlaca(placa) {
        if (placa) {
            if (!playmodal.playModalEven && !playmodal.playModalEvenPlaca) {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { 
                        ...parametroInit, 
                        loading: true,
                    }
                });
            };

            const res = await api.get(`veiculo/filtrar/placa/${placa}`);
            try {
                dispatch({
                    type: 'set_playLista',
                    payload: { ...playLista, playListaVeic: true }
                });

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaVeiculo: res.data? [res.data] : [],
                        alertaNovo: res.data? false : true,
                    }
                });

                if (res.data && playmodal.playModalEvenPlaca) {
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, novoCadastro: false }
                    });
                    
                } else {
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, novoCadastro: true }
                    });
                };

                return res.data;

            } catch (error) {
                alert("!!!! Ocorreu um erro..!!!!", error);
                return error;

            }finally{
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });
            };
        };
    };

    // ---------------------------------------------------
    async function PesqPlaca_Varias(placa) {
        if (placa) {
            if (!playmodal.playModalEven && !playmodal.playModalEvenPlaca) {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { 
                        ...parametroInit, 
                        loading: true,
                    }
                });
            };

            await api.get(`veiculo/filtrar/placaVarias/${placa}`)
                .then(res => {
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: {
                            ...parametroInit,
                            loading: false
                        }
                    });

                    dispatch({
                        type: 'set_playLista',
                        payload: { ...playLista, playListaVeic: true }
                    });

                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: {
                            ...listaPesquisa,
                            listaVeiculo: res.data? res.data : [],
                            alertaNovo: res.data? false : true,
                        }
                    });

                    if (res.data && playmodal.playModalEvenPlaca) {
                        dispatch({
                            type: 'SET_parametroInit',
                            payload: { ...parametroInit, novoCadastro: false }
                        });
                        
                    } else {
                        dispatch({
                            type: 'SET_parametroInit',
                            payload: { ...parametroInit, novoCadastro: true }
                        });
                    }
                });
        };
    };

    // ---------------------------------------------------
    async function PesqPlacaDigitado(placa) {
        if (placa) {
            await api.get(`veiculo/filtrar/placa/${placa}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: {
                            ...listaPesquisa,
                            listaVeiculo: res.data ? res.data : null,
                            alertaNovo: res.data || !playmodal.playModalEven ? false : true
                        }
                    });

                    if (res.data) {
                        dispatch({
                            type: 'set_ListaPesquisa',
                            payload: { ...listaPesquisa, nomeItem: "" }
                        });

                        dispatch({
                            type: 'set_veiculo',
                            payload: { ...veiculo, placa: "" }
                        });

                        dispatch({
                            type: 'SET_parametroInit',
                            payload: { ...parametroInit, novoCadastro: false }
                        });

                        if(playmodal.playModalEvenPlaca){
                            alert("Placa Ja Existe!");
                        };
                    } else {
                        dispatch({
                            type: 'SET_parametroInit',
                            payload: { ...parametroInit, novoCadastro: true }
                        });
                    }
                });
        };
    };

    //---------------Pesquisar Veiculos por Id------------
    async function pesqIDveiculo() {
        if (id_Veiculo) {
            await api.get(`veiculo/${id_Veiculo}`)
            .then(res => {

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaVeiculo: [res.data] }
                });

                if (res.data.id_cliente) {
                    dispatch({
                        type: 'set_cliente',
                        payload: { 
                            ...cliente, 
                            id_Cliente: res.data.id_cliente._id 
                        }
                    });
                };
            })
        }
    };

    // ------------------------------------------
    async function AtualizarVeiculo({idCliente}) {
        const campos = {
            id_Cliente: cliente.id_Cliente || idCliente,
            placa: veiculo.placa,
            valorFipe: veiculo.valorFipe,
            tipo: veiculo.tipo?.toLowerCase(),
            marca: veiculo.marca?.toLowerCase(),
            modelo: veiculo.modelo,
            anoMod: veiculo.anoMod,
            cor: veiculo.cor,
            chassi: veiculo.chassi,
            situacao: veiculo.situacao,
        };

        // Remover campos nulos
        Object.keys(campos).forEach(key => {
            if (campos[key] === null || campos[key] === undefined || campos[key] === "") {
                delete campos[key];
            }
        });

        try {
            const res = await api.put(`veiculo/atualizar/${veiculo.id_Veiculo}`, campos)
            if (res.data) {
                pesqIDveiculo();
                alert('✅ Dados do veículo atualizados com sucesso!');   

                dispatch({
                    type: 'SET_PLAYMODAL',
                    payload: { ...playmodal, playModalVeiculo: false }
                });
                
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, DadosLocalizado: false }  
                });
            };

            return res.data;
            
        } catch (error) {
            alert("!!!! Ocorreu um erro..!!!!", error);
            return error;
        }
    };

    // ------------------------------------------
    // Envia os arquivos (fotos/vídeo da vistoria) para o campo arquivos do veículo
    async function AtualizarArquivosVeiculo({ tipoFile, arquivosConvertidos }) {
        if (!veiculo.id_Veiculo) {
            alert("Nenhum veículo selecionado para atualizar!");
            return null;
        }

        const formData = new FormData();
        formData.append("veiculo", JSON.stringify({
            placa: veiculo.placa,
            tipoFile: tipoFile || "vistorias",
            data_modificado: Date.now(),
        }));

        (arquivosConvertidos || []).forEach((file, i) => {
            formData.append(`file[${i}]`, file);
        });

        try {
            const res = await api.put(`veiculo/atualizar/${veiculo.id_Veiculo}`, formData);
            if (res.data) await pesqIDveiculo();
            return res.data;
        } catch (error) {
            alert("!!!! Ocorreu um erro..!!!!");
            throw error;
        }
    };

    // ------------------------------------------
    async function AtualizarCotacao() {
        const campos = {
            id_Franquia: franquia?.id || null,
            valorFipe: veiculo?.valorFipe || null,
            valorCotacao: veiculo?.valorMensal || null,
            valorAdesao: veiculo?.valorAdesao || null,
            whatsapp: veiculo?.whatsapp_Cotacao || null,
            data: new Date(),
        };

        // Remover campos nulos
        Object.keys(campos).forEach(key => {
            if (campos[key] === null || campos[key] === undefined || campos[key] === "") {
                delete campos[key];
            }
        });

        try {
            const res = await api.put(`veiculo/atualizarCotacao/${cotacao.id_Cotacao}`, campos)
            if (res.data) {
                pesqCotacao_Id();
                alert('✅ Cotacao atualizada com sucesso!');   
            };

            return res.data;
            
        } catch (error) {
            alert("!!!! Ocorreu um erro..!!!!", error);
            return error;
        }
    };
    // ------------------------------------------
    async function AtualizarRegistro({idRegistro, status}) {
        try {
            const res = await api.put(`veiculo/upRegistro/${cotacao.id_Cotacao}`, {
                id_Registros: idRegistro,
                status: status,
            })
            if (res.data) {
                pesqCotacao_Id();
                alert('✅ Registro atualizado com sucesso!');   
            };

            return res.data;
            
        } catch (error) {
            alert("!!!! Ocorreu um erro..!!!!", error);
            return null;
        }
    };

    // ------------------------------------------------
    return { 
        PesqVeiculoPlaca, PesqPlacaDigitado, AddPlaca, AddCotacao,  
        PlanosTipo, TodosPlanos, TodosTipos, PesqVeiXcliente, pesqIDveiculo, 
        AtualizarVeiculo, AtualizarArquivosVeiculo, AtualizarCotacao, PesqPlaca_Varias, pesqCotacao_Id, pesqTodasCotacoes, AtualizarRegistro
    };
};
